import { Form, Formik } from "formik";
import React, { useState } from "react";
import styles from "../PrimaryBusinessAddress.module.css";
import { BusinessAddressType, SingleBusinessAddressType } from "types";
import SelectInput from "uicomponents/SelectInput";
import { errorMessageMap, getOfficeFullAddress } from "utils/helper";
import FooterButton from "uicomponents/FooterButton";
import Alert from "uicomponents/Alert";
import { useUpdateBussinessAddressMutation } from "types/generated/operations";
import {
  BACK_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
} from "pages/PreQualification/utils/constants";
import { usePreQualContext } from "pages/PreQualification/PreQualification";
import { trackFormError } from "utils/analytics/trackEvent";
import { addressDropdownValidationSchema } from "pages/PreQualification/utils/validationSchema";

interface IAddressDropdownProps {
  data: BusinessAddressType;
  handleNextClick: () => void;
}

interface AddressDropdownFormType {
  officeLocationId: string;
}
const AddressDropdown = ({ ...props }: IAddressDropdownProps): JSX.Element => {
  const { data, handleNextClick } = props;
  const { previousStep } = usePreQualContext();

  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [updateOfficeLocation, { loading: updateBussinessAddressLoading }] =
    useUpdateBussinessAddressMutation();

  const initialFormValues: AddressDropdownFormType = {
    officeLocationId: "",
  };
  const officeLocationOptions = data?.officeLocations?.map((address: any) => {
    const fullAddress = getOfficeFullAddress(address);

    return {
      value: address.uuid,
      description: fullAddress,
    };
  });

  const handleOnSubmit = async (values: AddressDropdownFormType) => {
    const selectedAddress = data?.officeLocations?.filter(
      (address: SingleBusinessAddressType) =>
        address.uuid === values.officeLocationId
    )?.[0];
    if (!selectedAddress) return;

    try {
      await updateOfficeLocation({
        variables: {
          uuid: selectedAddress?.uuid,
          address1: selectedAddress?.address1,
          address2: selectedAddress?.address2,
          city: selectedAddress?.city,
          zip: selectedAddress?.zip,
          state: selectedAddress?.state,
          locationName: selectedAddress?.locationName,
          isHq: true,
        },
      });
      handleNextClick();
    } catch (error: any) {
      const errorMessage: string = error?.message;
      errorMessageMap[errorMessage] &&
        setErrorMessage(errorMessageMap[errorMessage]);
      trackFormError(error, errorMessage);
      setIsError(true);
      return;
    }
  };

  return (
    <div>
      <div className={styles.title}>Primary business address</div>
      <div className={styles.description}>
        Select your Primary Business Address from the addresses we have saved
        for your company.
      </div>
      <Formik
        initialValues={initialFormValues}
        validationSchema={addressDropdownValidationSchema}
        onSubmit={handleOnSubmit}
      >
        {() => (
          <>
            <Form>
              <SelectInput
                name="officeLocationId"
                options={officeLocationOptions}
                label=""
                placeholder="Select an option"
              />
              <FooterButton
                nextButtonText={
                  updateBussinessAddressLoading
                    ? LOADING_BUTTON_TEXT
                    : NEXT_BUTTON_TEXT
                }
                backButtonText={BACK_BUTTON_TEXT}
                disabled={updateBussinessAddressLoading}
                handleBackClick={previousStep}
              />
              {isError && <Alert message={errorMessage} />}
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default AddressDropdown;
